import { isSafeInternalPath } from './redirect';

const ONBOARDING_RETURN_KEY = 'howcost.onboarding.returnTo';

/**
 * 온보딩을 마친 뒤 돌아갈 내부 경로(예: 데스크톱 로그인 동의 화면).
 *
 * 화면 state 로는 살아남지 못한다 — 온보딩 1단계(비밀번호 교체)가 임시 비밀번호로
 * 열린 세션을 끊어 재로그인(하드 리다이렉트)을 거치기 때문이다. 같은 탭에서만 유지한다.
 * 스토리지가 막힌 환경에서는 조용히 기본 경로로 떨어진다.
 */
export function rememberOnboardingReturn(path: string): void {
  if (!isSafeInternalPath(path)) return;
  try {
    sessionStorage.setItem(ONBOARDING_RETURN_KEY, path);
  } catch {
    // 저장 실패는 완료 후 마이페이지로 가는 것뿐이라 무시한다.
  }
}

/** 한 번 꺼내면 지운다 — 다음 온보딩에 남은 값이 끼어들지 않게. */
export function takeOnboardingReturn(): string | null {
  try {
    const value = sessionStorage.getItem(ONBOARDING_RETURN_KEY);
    sessionStorage.removeItem(ONBOARDING_RETURN_KEY);
    return isSafeInternalPath(value) ? value : null;
  } catch {
    return null;
  }
}

export function clearOnboardingReturn(): void {
  try {
    sessionStorage.removeItem(ONBOARDING_RETURN_KEY);
  } catch {
    // 접근 불가 환경은 남은 값도 없다.
  }
}
